/**
 * Permets de cacher un élément cible au clic en dehors de cet élément.
 *
 * @param {string} elementSelector Le sélecteur de l'élément cible
 * @param {string} elementToHideSelector Le sélecteur de l'élément à cacher
 */
export const hideOnClickOutside = (elementSelector, elementToHideSelector) => {
  const element = document.querySelector(elementSelector);
  const elementToHide = document.querySelector(elementToHideSelector);

  const outsideClickListener = (event) => {
    if (
      !element.contains(event.target) &&
      elementToHide.style.display !== 'none'
    ) {
      elementToHide.style.display = 'none';
    }
  };

  document.addEventListener('click', outsideClickListener);
};
